import I18n from 'i18n-js';
import React, { useState } from 'react';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCButton, RCInfoBox } from '@reverbdotcom/cadence/components';
import { ProtectionShieldIcon } from '@reverbdotcom/cadence/icons/react';

import { Paths } from '../components/shared/url_helpers';

export function TruliooIdentityVerificationBanner() {
  const [isDismissed, setIsDismissed] = useState(false);

  const identityVerificationPath = Paths.coreIdentityVerification.expand({});

  if (isDismissed) { return null; }

  return (
    <div className="mt-8">
      <RCInfoBox
        variant="subtle-outlined"
        theme="vu-orange"
        svgComponent={ProtectionShieldIcon}
      >
        <div className="d-flex fx-justify-between">
          <div>
            <div className="size-120 weight-bold">
              {I18n.t('discovery.truliooIdentityVerificationBanner.title')}
            </div>
            <p className="mb-0">
              {I18n.t('discovery.truliooIdentityVerificationBanner.message')}
            </p>
            <CoreLink
              to={identityVerificationPath}
              className="color-primary td-underline"
              target="_blank"
            >
              {I18n.t('discovery.truliooIdentityVerificationBanner.verifyNow')}
            </CoreLink>
          </div>
          <div>
            <RCButton onClick={() => setIsDismissed(true)}>
              {I18n.t('discovery.truliooIdentityVerificationBanner.buttonText')}
            </RCButton>
          </div>
        </div>
      </RCInfoBox>
    </div>
  );
}

export default TruliooIdentityVerificationBanner;
